import { MvcState } from "@repo/models";

import { useRepContext } from "../contexts/editableItemContext";
import { OnboardingRequirementsFull } from "../models/onboardingRequirement";
import * as Queries from "./queries";
import { useQueryWrapper, useRepPortalApi } from "./repPortalApi";

export function useOnboardingSessionsApi() {
	const { repId } = useRepContext();
	const { Get } = useRepPortalApi();

	async function getPossibleStates(overrideRepId?: number) {
		const targetRepId = overrideRepId ?? repId;
		return await Get<MvcState[]>("GetPossibleStates", { repId: targetRepId });
	}

	async function getOnboardingRequirementsBySegment(repSegmentId: number) {
		return !repId
			? null
			: await Get<OnboardingRequirementsFull>("GetOnboardingRequirementsBySegment", { repId, repSegmentId });
	}

	async function getOnboardingRequirements() {
		return !repId ? null : await Get<OnboardingRequirementsFull>("GetOnboardingRequirements", { repId });
	}

	const possibleStatesQuery = useQueryWrapper(
		Queries.ONBOARDING_POSSIBLE_STATES,
		[repId],
		() => getPossibleStates(),
		{
			enabled: !!repId,
		},
	);

	const onboardingRequirementsQuery = useQueryWrapper(
		Queries.ONBOARDING_REQUIREMENTS,
		[repId],
		getOnboardingRequirements,
	);

	return {
		possibleStatesQuery,
		onboardingRequirementsQuery,
		getOnboardingRequirementsBySegment,
		getPossibleStates,
	};
}
